"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CampaignCreativeRotationDto = exports.CampaignCreativeDto = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const campaign_media_adaptations_dto_1 = require("./campaign-media-adaptations.dto");
/** One logical turn; its variants do not create additional campaign slots. */
class CampaignCreativeDto {
    creativeId;
    assetIds;
    assignments;
}
exports.CampaignCreativeDto = CampaignCreativeDto;
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.MaxLength)(128),
    __metadata("design:type", String)
], CampaignCreativeDto.prototype, "creativeId", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ArrayMinSize)(1),
    (0, class_validator_1.ArrayMaxSize)(100),
    (0, class_validator_1.ArrayUnique)(),
    (0, class_validator_1.IsMongoId)({ each: true }),
    __metadata("design:type", Array)
], CampaignCreativeDto.prototype, "assetIds", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ArrayMinSize)(1),
    (0, class_validator_1.ArrayMaxSize)(10000),
    (0, class_validator_1.ArrayUnique)((assignment) => assignment?.displayId),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => campaign_media_adaptations_dto_1.CampaignMediaAssignmentDto),
    __metadata("design:type", Array)
], CampaignCreativeDto.prototype, "assignments", void 0);
/** Explicit opt-in contract. Array order is playback order, never asset sorting order. */
class CampaignCreativeRotationDto {
    version;
    summaryRevision;
    creatives;
}
exports.CampaignCreativeRotationDto = CampaignCreativeRotationDto;
__decorate([
    (0, class_validator_1.Equals)(1),
    __metadata("design:type", Number)
], CampaignCreativeRotationDto.prototype, "version", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], CampaignCreativeRotationDto.prototype, "summaryRevision", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ArrayMinSize)(2),
    (0, class_validator_1.ArrayMaxSize)(4),
    (0, class_validator_1.ArrayUnique)((creative) => creative?.creativeId),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => CampaignCreativeDto),
    __metadata("design:type", Array)
], CampaignCreativeRotationDto.prototype, "creatives", void 0);
